// The viewBox height is fixed and its width follows the container, so the scale — and with it
// font px and the left axis — stays the same at every width. GC_W_MIN (400/320) is the floor.
const GC_W_MIN = 400;
export const GC_H = 320;
export const GC_PAD_TOP = 24;
const GC_PAD_RIGHT = 24;
export const GC_PAD_LEFT = 44;
const GC_PAD_BOTTOM = 38;
export const GC_INNER_H = GC_H - GC_PAD_TOP - GC_PAD_BOTTOM;

export const X_TICK_COUNT = 4;
export const Y_TICK_COUNT = 5;

export type ChartSize = { width: number; innerWidth: number };

export function chartSize(containerWidth: number, containerHeight: number): ChartSize {
  const width =
    containerHeight > 0 ? Math.max(GC_W_MIN, (containerWidth / containerHeight) * GC_H) : GC_W_MIN;
  return { width, innerWidth: width - GC_PAD_LEFT - GC_PAD_RIGHT };
}

export type ChartTheme = {
  bgFill: string;
  axisStroke: string;
  labelFill: string;
  noDataFill: string;
  tickStroke: string;
};

const NIGHT: ChartTheme = {
  bgFill: '#343332',
  axisStroke: 'rgba(255,255,255,0.45)',
  labelFill: 'rgba(255,255,255,0.6)',
  noDataFill: 'rgba(255,255,255,0.4)',
  tickStroke: 'rgba(255,255,255,0.25)',
};
const DAY: ChartTheme = {
  bgFill: '#f0f0f0',
  axisStroke: 'rgba(0,0,0,0.35)',
  labelFill: 'rgba(0,0,0,0.65)',
  noDataFill: 'rgba(0,0,0,0.4)',
  tickStroke: 'rgba(0,0,0,0.2)',
};

export const chartTheme = (isDayMode: boolean): ChartTheme => (isDayMode ? DAY : NIGHT);
